__webpack_require__.p = "https://fos.lenovo.com/account/";